import { __decorate, __metadata } from "tslib";
import { Vue, Component, Inject } from 'vue-property-decorator';
import { E_LanguageLong } from 'library-components/apis/passport/types';
import { goToMoudle } from 'library-components/utils/goToMoudle';
import { applyAuthInterceptor } from 'library-components/config/authInterceptor';
import { getAlertDataByCode } from 'library-components/config/alertMsg';
import { GOOGLE_LOGIN_CLIENT_ID } from 'library-components/config/envConfig';
import { getAllVarsForLogin, postVar } from 'library-components/utils/environment';
import { registerUrlParamKeys } from 'library-components/apis/register/register.type';
import { decode } from 'js-base64';
import { postLoginSocialIndividualApi, postLoginSocialIndividualPasswordApi, getPublicKeyApi, } from 'library-components/apis/login/login';
import GoogleLoginPassWordDialog from '../GoogleLoginPassWordDialog/GoogleLoginPassWordDialog.vue';
import JSEncrypt from 'jsencrypt';
import _ from 'lodash';
import { MultiTenantSelectService } from '@/services/multiTenantSelectService';
import { E_ConfirmResult } from 'library-components/utils/task';
import { E_LoginMethod } from 'library-components/apis/login/login.type';
let GoogleLoginButtonImpl = class GoogleLoginButtonImpl extends Vue {
    constructor() {
        super(...arguments);
        this.isScriptReady = false;
        this.tokenData = null;
        this.showPasswordDialog = false;
        this.loginBoxWidth = 318;
        this.loginBoxLeft = 0;
        this.credential = '';
        this.multiTenantSelectService = new MultiTenantSelectService({
            selector: '.login-panel-body__content',
            i18n: this.$i18n,
        });
        this.loginErrorMsg = '';
    }
    injectScript() {
        const googleSdkUrl = 'https://accounts.google.com/gsi/client';
        if (this.isScriptReady) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.addEventListener('load', () => {
                this.isScriptReady = true;
                resolve();
            });
            script.addEventListener('error', reject);
            script.setAttribute('src', googleSdkUrl);
            document.body.appendChild(script);
        });
    }
    initPostion() {
        const containerWidth = this.$el.clientWidth;
        this.loginBoxWidth = containerWidth > 400 ? 400 : containerWidth;
        this.loginBoxLeft = (containerWidth - this.loginBoxWidth) / 2;
    }
    startApp() {
        this.initPostion();
        // eslint-disable-next-line
        const vm = this;
        // @ts-ignore
        google.accounts.id.initialize({
            client_id: GOOGLE_LOGIN_CLIENT_ID,
            callback: vm.handleCredentialResponse,
            cancel_on_tap_outside: false,
        });
        // @ts-ignore
        google.accounts.id.renderButton(document.getElementById('google_login_botton'), {
            width: vm.loginBoxWidth,
            type: 'standard',
            size: 'large',
            theme: 'outline',
            text: 'sign_in_with',
            shape: 'rectangular',
            locale: E_LanguageLong[this.$i18n.locale] || 'en_US',
            logo_alignment: 'center',
        });
    }
    handleCredentialResponse(response) {
        if (response.credential) {
            this.credential = response.credential;
            const tokenStr = response.credential.split('.')[1];
            this.tokenData = JSON.parse(decode(tokenStr));
            this.postLoginSocialIndividual();
        }
    }
    postLoginSocialIndividual() {
        const registerParams = getAllVarsForLogin([...registerUrlParamKeys]);
        this.multiTenantSelectService
            .init({
            google_id_token: this.credential,
        }, E_LoginMethod.google)
            .then((tenantResult) => {
            if (!tenantResult || tenantResult === E_ConfirmResult.CANCEL) {
                return;
            }
            postLoginSocialIndividualApi('google', {
                id_token: this.credential,
                ...registerParams,
            })
                .then((res) => {
                applyAuthInterceptor(res.token);
                goToMoudle();
            })
                .catch((err) => {
                const code = _.get(err, 'response.data.errcode') ||
                    _.get(err, 'response.data.numeric_error_code');
                if (code === 31619) {
                    this.showPasswordDialog = true;
                    this.loginErrorMsg = '';
                }
                else {
                    this.$emit('passport-error', {
                        errcode: code,
                        email: this.tokenData.email,
                    });
                }
            });
        })
            .catch((error) => {
            this.$emit('passport-error', {
                errcode: _.get(error, 'response.data.numeric_error_code'),
            });
        });
    }
    async postLoginSocialIndividualPassword(password) {
        const publicKey = await getPublicKeyApi();
        const encrypt = new JSEncrypt({});
        encrypt.setPublicKey(publicKey);
        const encryptPwd = encrypt.encrypt(password);
        postLoginSocialIndividualPasswordApi('google', {
            id_token: this.credential,
            password: encryptPwd,
        }).then(res => {
            applyAuthInterceptor(res.token);
            goToMoudle();
            this.showPasswordDialog = false;
        }).catch(err => {
            const code = _.get(err, 'response.data.errcode') || _.get(err, 'response.data.numeric_error_code');
            const urlData = getAllVarsForLogin(['from', 'redirect_uri', 'client_id']);
            const paramsUrl = postVar({ ...urlData });
            const { msg } = getAlertDataByCode({
                code,
                lang: this.$i18n.locale,
                serviceArea: _.get(this.commonService, 'Region', '').toLocaleLowerCase(),
                paramsUrl,
                userEmail: this.tokenData.email,
            });
            this.loginErrorMsg = msg;
        });
    }
    passwordSubmit({ password }) {
        this.postLoginSocialIndividualPassword(password);
    }
    async created() {
        await this.injectScript();
        this.startApp();
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], GoogleLoginButtonImpl.prototype, "commonService", void 0);
GoogleLoginButtonImpl = __decorate([
    Component({
        components: {
            GoogleLoginPassWordDialog,
        },
    })
], GoogleLoginButtonImpl);
export { GoogleLoginButtonImpl };
